import { render, staticRenderFns } from "./ChatBoxReplyProfile.vue?vue&type=template&id=68123ae8&scoped=true&"
import script from "./ChatBoxReplyProfile.vue?vue&type=script&lang=js&"
export * from "./ChatBoxReplyProfile.vue?vue&type=script&lang=js&"
import style0 from "./ChatBoxReplyProfile.vue?vue&type=style&index=0&id=68123ae8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68123ae8",
  null
  
)

export default component.exports